import { config } from './config';

// Headers every backend request carries regardless of endpoint. Lifted from
// weebee_web/packages/api/src/client.ts, where it was the single source shared by
// the openapi-fetch middleware and the plain-fetch wrappers. Only the wrapper
// (lib/http.ts) survives here, but keeping this in its own module preserves the
// property that a future second caller cannot forget the product header.
//
// A silent `unknown` in the backend's product label means this got dropped in a
// refactor — it degrades origin_product attribution with no visible error.
export function getCommonHeaders(): Record<string, string> {
  return { 'X-Client-Product': config.clientProduct };
}
